const slides = [
  {
    title: "Background",
    subtitle: "Software Engineer with 4+ Years of Experience",
    text: "I specialize in Node.js, TypeScript, GraphQL, and building clean, scalable systems. I’ve deployed apps into Kubernetes clusters and cloud platforms like AWS and IBM Cloud.",
    image: "/slides/placeholder.jpg"
  },
  {
    title: "DevOps & Cloud",
    subtitle: "Engineering Beyond the Code",
    text: "From containerized applications to CI/CD pipelines, I bring full-stack engineering together with DevOps practices to build resilient and maintainable systems.",
    image: "/slides/placeholder.jpg"
  },
  {
    title: "My Story",
    subtitle: "Passion Found Through Experience",
    text: "I began in Electrical Engineering with a full scholarship at Bilkent, but shifted to Computer Engineering at Bahcesehir to follow my true passion — building software.",
    image: "/slides/placeholder.jpg"
  },
  {
    title: "Motivated & Certified",
    subtitle: "A Learner for Life",
    text: "I recently earned my AWS Developer Associate Certification and I’m working on more. I’m constantly learning and eager to grow within a great engineering culture.",
    image: "/slides/placeholder.jpg"
  },
  {
    title: "Let’s Build Something Great",
    subtitle: "Open to New Challenges",
    text: "Let’s collaborate and create something meaningful — software that scales, performs, and solves real problems. Ready when you are.",
    image: "/slides/placeholder.jpg"
  }
];

export default slides;
